<template>
  <div class="base-user-infos-wrap account-infos-wrap">
    <TitleCard :title="titleCard" :showMore="showMore">
      <template slot="rightOperation">
        <div class="btn-wrap">
          <a-button class="btn-item" @click="save">保存</a-button>
          <a-button class="btn-item" @click="showModal">修改密码</a-button>
          <changePsw ref="modal" v-if="isShowPsw" @cancel="cancel"></changePsw>
        </div>
      </template>
      <Form
        ref="form1"
        layoutType="grid"
        rowJustify="center"
        :optionList="userInfoFromRow"
        :defaultModel="defaultModel"
        :formRules="formRules"
      ></Form>
    </TitleCard>
    <TitleCard :title="titleCardTwo" :showMore="showMore">
      <Form
        ref="form2"
        layoutType="grid"
        rowJustify="center"
        :optionList="companyFromRow"
        :defaultModel="defaultModel"
        :formRules="formRules"
      ></Form>
    </TitleCard>
  </div>
</template>

<script>
import mixinsBackStack from '@/mixins/backStack';
import Form from '../../components/formTable/form.vue';
import changePsw from '../../components/changePsw';
import { userInfoFromRow, companyFromRow, formRules } from './configs/configs';
import { getAccountInfos, saveAccountInfos } from '@/api/accountInfos.js';
import { mapMutations } from 'vuex';

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      userInfoFromRow,
      companyFromRow,
      defaultModel: {},
      saveParam: {},
      titleCardTwo: '机构信息',
      isShowPsw: false,
      formRules,
    };
  },
  components: {
    Form,
    changePsw,
  },
  async mounted() {
    this.initRequest();
  },
  methods: {
    ...mapMutations('user', ['UPDATE_USER_NAME']),
    async initRequest() {
      const { data } = await getAccountInfos();
      this.defaultModel = { ...data };
    },
    // 保存
    async save() {
      const v1 = this.$refs.form1.validatedForm();
      const v2 = this.$refs.form2.validatedForm();
      if (!v1 || !v2) return;
      const refV = this.$refs.form1.formModel; // 获取表单中的值
      const refV2 = this.$refs.form2.formModel; // 获取表单中的值
      const saveParam = { ...refV, ...refV2 }; // 重置参数
      Object.assign(this.saveParam, saveParam); // 更新过滤参数
      let saveParams = {
        userName: saveParam.userName,
        phonenumber: saveParam.phonenumber,
        enpAddress: saveParam.enpAddress,
        enpPhone: saveParam.enpPhone,
        enpContact: saveParam.enpContact,
        enpNo: saveParam.enpNo,
        // enpName: saveParam.enpName,
        // email: saveParam.email
      };
      const res = await saveAccountInfos(saveParams);
      if (res.code === 200) {
        this.$message.success(res.msg);
        this.UPDATE_USER_NAME(saveParams.userName); // 保存用户新更新的名字
        this.initRequest();
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 修改密码
    showModal() {
      // const res = await editAccountInfos()
      // console.log(res)
      // this.visible = true
      // console.log(this.$refs.modal)
      // this.$refs.modal.showModal()
      // console.log(111)
      this.isShowPsw = true;
    },
    cancelVisible() {
      this.isShowPsw = false;
    },
    cancel() {
      this.isShowPsw = false;
    },
  },
};
</script>
